import React from "react"
import clsx from "clsx"
import List from "../../List/List"
import RateBuilderErrors from "../../RateBuilder/RateBuilderErrors"

class RatePresenterTaxesAndFees extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'taxes_and_fees',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="taxes_and_fees">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <h3 className="panel-heading-text">{I18n.t("taxes")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { this.props.taxes &&  this.props.taxes.length
                    ?
                      <List
                        header_primary="name"
                        items={this.props.taxes}
                        display_column_primary={"name"}
                        />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="panel panel-default">
              <div className="panel-body container">
                <h3 className="panel-heading-text">{I18n.t("fees")}</h3>
                <div className="row">
                  <div className="col-md-12">
                    { this.props.fees && this.props.fees.length
                    ?
                    <List
                      header_primary="name"
                      items={this.props.fees}
                      display_column_primary={"name"}
                      />
                    :
                      <div className="no-records">
                        <span className="none">{I18n.t('none')}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12" >
            <div className="alert alert-info" role="alert">{I18n.t('tax_and_fee_directions')}</div>
          </div>

        </div>
      </div>
    )
  }

  renderErrors() {
    var errors = RateBuilderErrors.taxes_and_fees(this.props.errors)
    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

}

export default RatePresenterTaxesAndFees